<template>
    <div class='tep-officials-wrap'>
        <dx-button hint="Добавить адрес к наименованию" width='32px' height='32px' @click="openNsi">
            <img :src="'/infoenergo/assets/tep/tep-cards/arrow-right.svg'" alt='' class='w-full h-full'>
        </dx-button>
    </div>
</template>

<script setup>
import { DxButton } from 'devextreme-vue';
import { dxUiNotify } from '@/utils/dx-helper';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    }
});

const openNsi = () => {
    dxUiNotify('Функция в разработке', 'info', 3000);
    console.log('fieldsMeta', props.meta.fieldsMeta);
}
</script>

<style scoped>
.tep-officials-wrap {
    display: flex;
    align-items: center;
    width: max-content;
    padding-top: 10px;
}
</style>
